export default __webpack_public_path__ + "static/media/ourteam2.7c0e1036.png";